import { removeParamsFromQuery } from '@marketplace-web/shared/utils'
import { BrandModel, CatalogNavigationModel } from '@marketplace-web/catalog/catalog-data'

// These parameters weaken the link's SEO effect
const PROHIBITED_SEO_PARAMS = [
  'search_start_type',
  'homepage_session_id',
  'disabled_personalization',
  'catalog_from',
  'referrer',
  'time',
]

export const removeCatalogSeoParams = (url: string, isBot: boolean) => {
  if (!isBot) return url
  if (!url.includes('/catalog') && !url.includes('/brand/')) return url

  const [path, search] = url.split('?')
  if (!search) return path || ''

  return removeParamsFromQuery(path || '', search, PROHIBITED_SEO_PARAMS)
}

export const getPageTitle = (
  seo?: { title: string; description?: string } | null,
  catalog?: CatalogNavigationModel | null,
  brand?: BrandModel | null,
): string | undefined => {
  if (seo?.title) return seo.title

  if (catalog?.title && brand?.title) return `${catalog.title} ${brand.title}`

  return catalog?.title || brand?.title
}
